import { render, staticRenderFns } from "./InsightUser.vue?vue&type=template&id=4aa9f6e7"
import script from "./InsightUser.vue?vue&type=script&lang=js"
export * from "./InsightUser.vue?vue&type=script&lang=js"
import style0 from "./InsightUser.vue?vue&type=style&index=0&id=4aa9f6e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports